export const DefaultOption = {
    de: {
        title: "Ist deine Entscheidung vorbestimmt?",
        description: "Wie beeinflussen Voreinstellungen deine Entscheidungen bei Online-Buchungen? In diesem Experiment erlebst du, wie Default-Optionen wirken.",
        screens: {
            screen1: {
                introTitle: "Flugbuchung nach Norwegen",
                intro: [
                    "Deine Familie hat gemeinsam entschieden, den Sommerurlaub in Norwegen zu verbringen. Ihr möchtet zuerst nach Oslo fliegen und dort ein paar Tage die Stadt und ihre Sehenswürdigkeiten erkunden.",
                    "Nach kurzer Recherche habt ihr euch für einen Flug mit der Airline NorwAir entschieden. Gemeinsam mit dir möchten deine Eltern die Buchung vornehmen, um dir zu zeigen, wie eine Online-Flugbuchung abläuft."
                ],
                airlineLogoAlt: "NorwAir Logo",
                beforeBookingNotice: "Bevor du mit der Flugbuchung fortfährst, erscheint ein Hinweis:",
                cookieBanner: {
                    title: "Cookie-Einstellungen",
                    description: "Wir verwenden Cookies, um Ihre Erfahrung zu verbessern, Inhalte zu personalisieren und die Nutzung unserer Website zu analysieren. Weitere Informationen finden Sie in unseren Datenschutzhinweisen.",
                    options: [
                        {
                            label: "Cookies annehmen",
                            hint: "Empfohlen für ein optimales Nutzungserlebnis."
                        },
                        {
                            label: "Cookies ablehnen",
                            hint: "Nur essentielle Cookies werden gesetzt."
                        }
                    ],
                    info: "Sie können Ihre Auswahl später jederzeit ändern.",
                    icon: "shield"
                },
                reasonLabel: "Bitte begründe deine Wahl:",
                reasonRequired: "(erforderlich)",
                reasonPlaceholder: "Bitte gib eine kurze Begründung ein."
            },
            screen2: {
                introTitle: "Flugbuchung nach Norwegen",
                intro: [
                    "Deine Familie hat gemeinsam entschieden, dass ihr den Sommerurlaub in Norwegen verbringen wollt.",
                    "Ihr möchtet zuerst nach Oslo fliegen und dort ein paar Tage die Stadt und ihre Sehenswürdigkeiten erkunden.",
                    "Nach kurzer Recherche habt ihr euch für einen Flug mit der Airline NorwAir entschieden. Deine Eltern möchten die Buchung gemeinsam mit dir vornehmen, damit du lernst, wie das funktioniert."
                ],
                airlineLogoAlt: "NorwAir Logo",
                beforeBookingNotice: "Bevor du mit der Flugbuchung fortfährst, erscheint ein Hinweis:",
                cookieBanner: {
                    title: "Cookie-Einstellungen",
                    description: "Wir verwenden Cookies, um Ihre Erfahrung zu verbessern, Inhalte zu personalisieren und die Nutzung unserer Website zu analysieren. Weitere Informationen finden Sie in unseren Datenschutzhinweisen.",
                    options: [
                        {
                            label: "Cookies annehmen",
                            hint: "Empfohlen für ein optimales Nutzungserlebnis."
                        },
                        {
                            label: "Cookies ablehnen",
                            hint: "Nur essentielle Cookies werden gesetzt."
                        }
                    ],
                    info: "Sie können Ihre Auswahl später jederzeit ändern.",
                    icon: "shield"
                },
                reasonLabel: "Bitte begründe deine Wahl:",
                reasonRequired: "(erforderlich)",
                reasonPlaceholder: "Bitte gib eine kurze Begründung ein."
            },
            screen3: {
                introTitle: "CO₂-Kompensation beim Flug",
                intro: [
                    "Nach der Cookie-Auswahl wählt ihr gemeinsam passende Flugdaten aus und gebt die persönlichen Daten für die Buchung ein.",
                    "Nachdem deine Eltern die Bezahlmöglichkeit ausgewählt haben, müsst ihr alle Angaben nochmal prüfen."
                ],
                compensationImgAlt: "CO₂-Kompensation",
                beforeBookingNotice: "Bevor ihr die Buchung abschließt, erscheint folgender Hinweis:",
                compensationBanner: {
                    title: "CO₂-Kompensation beim Flug",
                    description: "Für 12 € kannst du freiwillig den CO₂-Ausstoß deines Hin- und Rückflugs kompensieren. Das Geld wird in zertifizierte Klimaschutzprojekte investiert.",
                    options: [
                        {
                            label: "Ja, ich möchte die CO₂-Kompensation buchen."
                        },
                        {
                            label: "Nein, ich möchte keine CO₂-Kompensation buchen."
                        }
                    ],
                    icon: "globe"
                },
                reasonLabel: "Bitte begründe deine Wahl:",
                reasonRequired: "(erforderlich)",
                reasonPlaceholder: "Bitte gib eine kurze Begründung ein."
            },
            screen4: {
                introTitle: "CO₂-Kompensation beim Flug",
                intro: [
                    "Nach der Cookie-Auswahl wählt ihr gemeinsam passende Flugdaten aus und gebt die persönlichen Daten für die Buchung ein.",
                    "Nachdem deine Eltern die Bezahlmöglichkeit ausgewählt haben, müsst ihr alle Angaben nochmal prüfen."
                ],
                compensationImgAlt: "CO₂-Kompensation",
                beforeBookingNotice: "Bevor ihr die Buchung abschließt, erscheint folgender Hinweis:",
                compensationBanner: {
                    title: "CO₂-Kompensation beim Flug",
                    description: "Für 12 € kannst du freiwillig den CO₂-Ausstoß deines Hin- und Rückflugs kompensieren. Das Geld wird in zertifizierte Klimaschutzprojekte investiert.",
                    options: [
                        {
                            label: "Ja, ich möchte die CO₂-Kompensation buchen.",
                            hint: "Das Geld wird in zertifizierte Klimaschutzprojekte investiert."
                        },
                        {
                            label: "Nein, ich möchte keine CO₂-Kompensation buchen."
                        }
                    ],
                    icon: "globe"
                },
                reasonLabel: "Bitte begründe deine Wahl:",
                reasonRequired: "(erforderlich)",
                reasonPlaceholder: "Bitte gib eine kurze Begründung ein."
            }
        },
        explanation: {
            title: "Wie Voreinstellungen deine Entscheidungen beeinflussen",
            sections: {
                whatIsDefault: {
                    title: "Was sind Default-Optionen?",
                    content: "Beim Online-Shoppen, am Schulcomputer oder am Snackautomaten: Oft ist schon eine Option für dich vorausgewählt. Zum Beispiel: Der Drucker steht automatisch auf Schwarz-Weiß und doppelseitig. Diese Voreinstellungen nennt man Default-Optionen. Du kannst sie ändern, aber meistens lässt man alles so, wie es ist."
                },
                howDoTheyWork: {
                    title: "Wie beeinflussen sie unsere Entscheidungen?",
                    content: "Solche Voreinstellungen wirken wie ein kleiner Stupser: Was voreingestellt ist, scheint oft die beste Wahl zu sein. Das spart Zeit und wirkt einfach. Deshalb übernehmen viele Menschen den Default ohne große Überlegung, vor allem, wenn sie in Eile sind oder die Entscheidung unwichtig erscheint. Das nennt man den Default-Nudge. Anbieter nutzen ihn gezielt, z. B. um klimafreundliche Versandoptionen anzubieten oder zusätzliche Angebote anzuhaken. Dahinter steckt ein psychologischer Trick: Menschen bleiben gern beim Gewohnten. Diese Verzerrung nennt man auch Status-quo-Bias."
                },
                researchExample: {
                    title: "Ein bekanntes Beispiel aus der Forschung",
                    content: "Forschende wie der Verhaltensökonom Eric J. Johnson haben gezeigt, wie stark Voreinstellungen unser Verhalten beeinflussen können. Ein bekanntes Beispiel ist die Organspende: In Ländern wie Österreich oder Frankreich ist man automatisch Organspender, wenn man dem nicht ausdrücklich widerspricht <br>(„Widerspruchslösung“). In anderen Ländern, etwa Deutschland, muss man selbst aktiv zustimmen <br>(„Zustimmungslösung“) und zum Beispiel einen Organspendeausweis ausfüllen.\n\nDas Ergebnis: In Ländern mit der automatischen Organspende liegt die Zustimmungsrate oft über 90 %. In Ländern ohne diese Voreinstellung ist sie deutlich geringer."
                },
                ownExperiment: {
                    title: "Wie war das in unserem Experiment?",
                    content: "Sicher hast du die Ähnlichkeit zu unserem Experiment schon erkannt. Für die beiden Gruppen waren im Experiment unterschiedliche Optionen vorausgewählt. Für manche war die Auswahl für die Cookies schon gesetzt, für andere die Annahme der CO₂-Kompensation. Viele haben die Voreinstellung übernommen, obwohl sie natürlich frei wählen konnten!"
                }
            },
            sources: {
                title: "Quellen:",
                items: [
                    "Johnson, E. J., & Goldstein, D. (2003). Do Defaults Save Lives? Science, 302(5649), 1338–1339.",
                    "Thaler, R. H., & Sunstein, C. R. (2008). Nudge: Improving Decisions About Health, Wealth, and Happiness."
                ]
            }
        },
        results: {
            cookies: {
                title: "Ergebnisse: Cookie-Auswahl und Voreinstellung",
                group1: { title: "Gruppe 1: Cookies annehmen vorausgewählt" },
                group2: { title: "Gruppe 2: Cookies ablehnen vorausgewählt" },
                summary: "Du warst zufällig in <b>Gruppe {group}</b>, wo die Option <b>\"{default}\"</b> vorausgewählt war. Du hast dich für <b>\"{choice}\"</b> entschieden und damit <b>{alignment}</b> die Voreinstellung entschieden.",
                overall: "Gesamtübersicht: Entscheidung im Vergleich zur Voreinstellung",
                defaultChosen: "Default gewählt",
                againstDefault: "Gegen Default",
                loading: "Lade Ergebnisse…"
            },
            compensation: {
                title: "Ergebnisse: CO₂-Kompensation und Voreinstellung",
                group1: { title: "Gruppe 1: Kompensation ablehnen vorausgewählt" },
                group2: { title: "Gruppe 2: Kompensation annehmen vorausgewählt" },
                summary: "Du warst zufällig in <b>Gruppe {group}</b>, wo die Option <b>\"{default}\"</b> vorausgewählt war. Du hast dich für <b>\"{choice}\"</b> entschieden und damit <b>{alignment} die Voreinstellung</b> entschieden.",
                overall: "Gesamtübersicht: Entscheidung im Vergleich zur Voreinstellung",
                defaultChosen: "Default gewählt",
                againstDefault: "Gegen Default",
                loading: "Lade Ergebnisse…"
            },
            default: {
                title: "Default-Nudge – Globale Ergebnisse",
                defaultChosen: "Voreinstellung gewählt",
                againstDefault: "Anders entschieden",
                loading: "Lade globale Ergebnisse…"
            }
        }
    },
    en: {
        title: "Is Your Choice Predetermined?",
        description: "How do preset options influence your decisions in online bookings? In this experiment, you'll experience the effect of default options.",
        screens: {
            screen1: {
                introTitle: "Flight booking to Norway",
                intro: [
                    "Your family has decided to spend your summer vacation together in Norway. First, you want to fly to Oslo and explore the city and its sights for a few days. Then you will travel to the back country.",
                    "After a short search, you decide to fly with NorwAir. Your parents want to book together with you to show you how online flight booking works."
                ],
                airlineLogoAlt: "NorwAir Logo",
                beforeBookingNotice: "Before you continue with the flight booking, the following Pop-Up appears:",
                cookieBanner: {
                    title: "Cookie Settings",
                    description: "We use cookies to enhance your experience, personalize content, and analyze usage of our website. For more information, see our privacy policy.",
                    options: [
                        {
                            label: "Accept cookies",
                            hint: "Recommended for an optimal experience."
                        },
                        {
                            label: "Reject cookies",
                            hint: "Only essential cookies will be set."
                        }
                    ],
                    info: "You can change your selection at any time later.",
                    icon: "shield"
                },
                reasonLabel: "Please explain your choice:",
                reasonRequired: "(required)",
                reasonPlaceholder: "Please enter a brief explanation."
            },
            screen2: {
                introTitle: "Flight booking to Norway",
                intro: [
                    "Your family has decided to spend your summer vacation in Norway.",
                    "First, you want to fly to Oslo and explore the city and its sights for a few days.",
                    "After a short search, you chose a flight with NorwAir. Your parents want to book together with you so you learn how it works."
                ],
                airlineLogoAlt: "NorwAir Logo",
                beforeBookingNotice: "Before you continue with the flight booking, the following notice appears:",
                cookieBanner: {
                    title: "Cookie Settings",
                    description: "We use cookies to enhance your experience, personalize content, and analyze usage of our website. For more information, see our privacy policy.",
                    options: [
                        {
                            label: "Accept cookies",
                            hint: "Recommended for an optimal experience."
                        },
                        {
                            label: "Reject cookies",
                            hint: "Only essential cookies will be set."
                        }
                    ],
                    info: "You can change your selection at any time later.",
                    icon: "shield"
                },
                reasonLabel: "Please explain your choice:",
                reasonRequired: "(required)",
                reasonPlaceholder: "Please enter a brief explanation."
            },
            screen3: {
                introTitle: "CO₂ compensation for the flight",
                intro: [
                    "After the cookie selection, you jointly choose suitable flight dates and enter personal information for the booking.",
                    "After your parents have selected the payment method, you need to check all details again."
                ],
                compensationImgAlt: "CO₂ compensation",
                beforeBookingNotice: "Before you complete the booking, the following notice appears:",
                compensationBanner: {
                    title: "CO₂ Compensation for the Flight",
                    description: "For €12 you can voluntarily compensate for the CO₂ emissions of your round-trip flight. The money is invested in certified climate protection projects.",
                    options: [
                        {
                            label: "Yes, I want to book the CO₂ compensation."
                        },
                        {
                            label: "No, I do not want to book the CO₂ compensation."
                        }
                    ],
                    icon: "globe"
                },
                reasonLabel: "Please explain your choice:",
                reasonRequired: "(required)",
                reasonPlaceholder: "Please enter a brief explanation."
            },
            screen4: {
                introTitle: "CO₂ compensation for the flight",
                intro: [
                    "After the cookie selection, you jointly choose suitable flight dates and enter personal information for the booking.",
                    "After your parents have selected the payment method, you need to check all details again."
                ],
                compensationImgAlt: "CO₂ compensation",
                beforeBookingNotice: "Before you complete the booking, the following notice appears:",
                compensationBanner: {
                    title: "CO₂ Compensation for the Flight",
                    description: "For €12 you can voluntarily compensate for the CO₂ emissions of your round-trip flight. The money is invested in certified climate protection projects.",
                    options: [
                        {
                            label: "Yes, I want to book the CO₂ compensation.",
                            hint: "The money is invested in certified climate protection projects."
                        },
                        {
                            label: "No, I do not want to book the CO₂ compensation."
                        }
                    ],
                    icon: "globe"
                },
                reasonLabel: "Please explain your choice:",
                reasonRequired: "(required)",
                reasonPlaceholder: "Please enter a brief explanation."
            }
        },
        explanation: {
            title: "How Defaults Influence Your Decisions",
            sections: {
                whatIsDefault: {
                    title: "What are default options?",
                    content: "When yo do online-shopping, work at the school's computer, or select a snack at a vending machine, there is often already one option preselected for you. For example: The printer is set to black-and-white and double-sided by default. These presets are called default options. You can change them, but most people leave them as they are."
                },
                howDoTheyWork: {
                    title: "How do they influence our decisions?",
                    content: "Such presets act as a little nudge: What is pre-set often seems like the best choice. It saves time and feels easy. That's why many people accept the default without much thought, especially when in a hurry or when the decision seems unimportant. This is called the default nudge. Providers use it specifically, e.g., to offer climate-friendly shipping options or pre-select extra offers. This is based on a psychological trick: People like to stick with what they're used to. This bias is also called status quo bias."
                },
                researchExample: {
                    title: "A well-known research example",
                    content: "Researchers, such as behavioral economist Eric J. Johnson, have shown how strongly presets can influence our behavior. A well-known example is organ donation: In countries like Austria or France, you are automatically an organ donor unless you explicitly object (opt-out). In other countries, such as Germany, you have to actively opt-in and, for example, fill out an organ donor card.\n\nThe result: In countries with automatic organ donation, the consent rate is often above 90%. In countries without this preset, it is significantly lower."
                },
                ownExperiment: {
                    title: "Our own experiment",
                    content: "You surely noticed the similarity to our experiment. The two groups in the experiment had different options pre-selected. For some, the cookie selection was already set; for others, the CO₂ compensation was preselected. Many chose the preset, although they could have chosen freely!"
                }
            },
            sources: {
                title: "Sources:",
                items: [
                    "Johnson, E. J., & Goldstein, D. (2003). Do Defaults Save Lives? Science, 302(5649), 1338–1339.",
                    "Thaler, R. H., & Sunstein, C. R. (2008). Nudge: Improving Decisions About Health, Wealth, and Happiness."
                ]
            }
        },
        results: {
            cookies: {
                title: "Results: Cookie Selection and Default Option",
                group1: { title: "Group 1: Accept cookies preselected" },
                group2: { title: "Group 2: Reject cookies preselected" },
                summary: "You were randomly assigned to <b>Group {group}</b>, where the option <b>\"{default}\"</b> was preselected. You chose <b>\"{choice}\"</b> and thus decided <b>{alignment}</b> the preset.",
                overall: "Overview: Decision compared to preset",
                defaultChosen: "Default chosen",
                againstDefault: "Against default",
                loading: "Loading results…"
            },
            compensation: {
                title: "Results: CO₂ Compensation and Default Option",
                group1: { title: "Group 1: Compensation rejection preselected" },
                group2: { title: "Group 2: Compensation acceptance preselected" },
                summary: "You were randomly assigned to <b>Group {group}</b>, where the option <b>\"{default}\"</b> was preselected. You chose <b>\"{choice}\"</b> and thus decided <b>{alignment} the preset</b>.",
                overall: "Overview: Decision compared to preset",
                defaultChosen: "Default chosen",
                againstDefault: "Against default",
                loading: "Loading results…"
            },
            default: {
                title: "Default Nudge – Global Results",
                defaultChosen: "Chose preset option",
                againstDefault: "Chose otherwise",
                loading: "Loading global results…"
            }
        }
    }
};